import styles from './tableOfContent.module.css';

export const TableOfContent = ({
  headings,
  activeHeadingId,
  onHeadingClick,
}) => {
  return (
    <article className="bg-white dark:bg-transparent dark:bg-gradient-to-b dark:from-[#1717172b] dark:via-[#2d37372b] dark:to-[#1717172b] px-[20px] py-[28px] dark:border dark:border-[#0C3438] rounded-[18px]">
      <header className="mb-[30px] ml-3">
        <h3 className="font-inter-tight text-black dark:text-[#89D7DF] uppercase leading-none">
          Table of content
        </h3>
      </header>

      <ol
        className={`space-y-4 pr-6 max-h-[330px] font-inter-tight text-sm list-outside capitalize ${styles.customScrollbar}`}
      >
        {headings.map(({ heading, scrollIdForHeading }, index) => {
          const isHeadingActive = activeHeadingId === scrollIdForHeading;
          return (
            <li
              key={index}
              className="relative pl-3 text-[#747474] hover:text-[#020c0dc2] dark:hover:text-[#b9b9b9d9] dark:text-[#99999999] cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                onHeadingClick(scrollIdForHeading);
              }}
            >
              <a
                href={`#${scrollIdForHeading}`}
                aria-label={`Jump to section: ${heading}`}
                className={`transition-all pl-[-8px] duration-200 ${
                  isHeadingActive ? ' text-[#020C0D] dark:text-[#B9B9B9]' : ''
                }`}
              >
                {heading}
              </a>
            </li>
          );
        })}
      </ol>
    </article>
  );
};
